import _objectSpread from "/Users/michaelwang/Career/JiaLin_Project/meow-admin-vue/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import Hamburger from '@/components/Hamburger';
import Screenfull from '@/components/Screenfull';
import SizeSelect from '@/components/SizeSelect';
import headUrl from '@/assets/default_image/head-default.png';
import { updatePassword } from '@/api/login';
export default {
  components: {
    Breadcrumb: Breadcrumb,
    Hamburger: Hamburger,
    Screenfull: Screenfull,
    SizeSelect: SizeSelect
  },
  computed: _objectSpread({}, mapGetters(['sidebar', 'name', 'avatar', 'device'])),
  data: function data() {
    return {
      headUrl: headUrl,
      updatePasswordVisible: false,
      updateForm: {
        newPassword: '',
        newPasswordConfirm: '',
        oldPassword: ''
      },
      rules: {
        oldPassword: [{
          required: true,
          message: '请输入旧密码',
          trigger: 'blur'
        }, {
          min: 6,
          max: 16,
          message: '请输入6-16位有效密码',
          trigger: 'blur'
        }],
        newPassword: [{
          required: true,
          message: '请输入新密码',
          trigger: 'blur'
        }, {
          min: 6,
          max: 16,
          message: '请输入6-16位有效密码',
          trigger: 'blur'
        }],
        newPasswordConfirm: [{
          required: true,
          message: '请再次输入新密码',
          trigger: 'blur'
        }, {
          min: 6,
          max: 16,
          message: '请输入6-16位有效密码',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('toggleSideBar');
    },
    logout: function logout() {
      var _this = this;
      this.$store.dispatch('LogOut').then(function () {
        _this.$router.push("/login");
      });
    },
    handleUpdatePassword: function handleUpdatePassword() {
      this.updateForm = {
        newPassword: '',
        newPasswordConfirm: '',
        oldPassword: ''
      };
      this.updatePasswordVisible = true;
    },
    confirmUpdatePassword: function confirmUpdatePassword() {
      var _this2 = this;
      this.$refs['updateForm'].validate(function (valid) {
        if (valid) {
          if (_this2.updateForm.newPasswordConfirm !== _this2.updateForm.newPassword) {
            _this2.$notify.error('两次密码不一致，请确认新密码');
            return;
          }
          updatePassword(_this2.updateForm).then(function (res) {
            _this2.$notify.success('密码修改成功');
            _this2.updatePasswordVisible = false;
          }).catch(function () {
            _this2.$notify.error('密码修改失败');
          });
        }
      });
    }
  }
};